<template>
  <div class="user-upsert-form">
    <div class="input-group">
      <dg-input type="text" v-model="formData.name" placeholder="Name" />
      <dg-input type="text" v-model="formData.email" placeholder="E-mail" />
      <dg-input type="text" v-model="formData.phoneNumber" placeholder="Phone" />
      <dg-input type="text" v-model="formData.address" placeholder="Address" />

      <div class="split">
        <dg-input type="text" v-model="formData.zip" placeholder="Zip" />
        <dg-input type="text" v-model="formData.city" placeholder="City" />
      </div>

      <picker
        :api="$api.countries.index"
        v-model="formData.countryId"
        value-key="id"
        placeholder="Country" />

      <picker
          :api="$api.organizations.index"
          v-model="formData.organizationIds"
          value-key="id"
          multiple
          hide-placeholder
          placeholder="Add to organization(s)" />

      <div class="split" v-if="!user">
        <dg-input type="text" v-model="formData.password" placeholder="Password" />
        <dg-input type="text" v-model="formData.confirmPassword" placeholder="Confirm password" />
      </div>

      <el-checkbox class="admin-checker" @change="systemAccessPrompt" v-model="formData.isSystem">Divegas system admin</el-checkbox>

      <el-button type="primary" icon="el-icon-upload" @click="handleAction">Save</el-button>
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'UserUpsertForm',
  components: { Picker },
  props: {
    user: {
      type: Object
    }
  },
  data () {
    return {
      originalData: {
        organizationIds: []
      },
      isSystemHasChanged: false,
      formData: {
        name: '',
        email: '',
        phoneNumber: '',
        address: '',
        zip: '',
        city: '',
        currencyId: '',
        countryId: '',
        isSystem: false,
        organizationIds: [],
        password: null,
        confirmPassword: null
      }
    }
  },
  methods: {
    handleAction () {
      if (this.isSystemHasChanged) {
        
      }

      if (this.user) {
        this.update()
      } else {
        this.add()
      }
    },
    getOrganizationDifference () {
      let organizationRemoval = []
      let organizationAddition = []

      this.originalData.organizationIds.forEach(id => {
        if (!this.formData.organizationIds.find(org => org === id)) {
          organizationRemoval.push(id)
        }
      })

       this.formData.organizationIds.forEach(id => {
        if (!this.originalData.organizationIds.find(org => org === id)) {
          organizationAddition.push(id)
        }
      })

      return {
        add: organizationAddition,
        remove: organizationRemoval
      }
    },
    systemAccessPrompt () {
      if (this.formData.isSystem) {
        this.$confirm(
          'You are about to give system privileges to this user, do you want to continue?', 
          'Are you sure?', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).catch(() => {
          this.formData.isSystem = false
        })
      }
    },
    async add () {
      const response = await this.$http.post(this.$api.users.create, this.formData)
      
      this.formData.organizationIds.forEach(async (id) => {
        const response = await this.$http.post(this.$api.organizations.users.create(id))
      })

      this.$message.success('User created successfully')
      this.$emit('add', response.data)
    },
    async update () {
      const response = await this.$http.put(this.$api.users.update(this.user.id), this.formData)

      const addRemove = this.getOrganizationDifference()
      addRemove.add.forEach(async (id) => {
        const res = await this.$http.post(this.$api.organizations.users.create(id), {
          userId: this.user.id,
          pending: false,
          invite: false
        })

        response.data.organizations.push(res.data)
      })
      addRemove.remove.forEach(async (id) => {
        const res = await this.$http.delete(this.$api.organizations.users.delete(id, this.user.id))
        const index = response.data.organizations.indexOf(response.data.organizations.find(org => org.organization.id === id))
        response.data.organizations.splice(index, 1)
      })
      
      
      this.$message.success('User updated successfully')
      this.$emit('update', response.data)
    }
  },
  created () {
    if (this.user) {
      this.formData.currencyId = this.user.currency.id
      this.formData.countryId = this.user.country.id
      this.formData.name = this.user.name
      this.formData.email = this.user.email
      this.formData.phoneNumber = this.user.phoneNumber
      this.formData.address = this.user.address
      this.formData.zip = this.user.zip
      this.formData.city = this.user.city
      this.formData.isSystem = this.user.isSystem
      this.formData.organizationIds = this.user.organizations.map(org => org.organization.id)
      this.originalData.organizationIds = this.user.organizations.map(org => org.organization.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .split {
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/UpsertForm.vue